// extracted by mini-css-extract-plugin
export var bodySections = "_7m-8";
export var gray = "_7m-7";
export var green = "_7m-4";
export var iconContainer = "_7m-9";
export var iconWidgetContainer = "_7m-1";
export var phoneIcon = "_7m-2";
export var red = "_7m-5";
export var statusDot = "_7m-3";
export var widgetContainer = "_7m-0";
export var yellow = "_7m-6";